module.exports = __webpack_public_path__ + "img/icn-bahasa.d5438c69.svg";